module.exports = __webpack_public_path__ + "img/form-o-2.762a6900.svg";